export default __webpack_public_path__ + "static/media/banner-doubt-mobile.a940a0f9.png";